import {logErr} from "./debugLog";
// import isStringValidHtml from "./isStringValidHtml";

export const parseTotalServicesHtml = (html) => {

    /*
    const isValidHtml = isStringValidHtml(html);
    if(!isValidHtml.isStringValidHtml) {
        logErr('Invalid HTML markup in total services');
        return false;
    }
    */

    const titleRegex = /<p>(.*?)<\/p>/g;
    const spanRegex = /<span>(.*?)<\/span>/g;
    const bodyRegex = /<ul>[\s\S]*?<\/ul>/g;

    let titles = [];
    let spans = [];
    let bodies = [];
    let match;

    while ((match = titleRegex.exec(html)) !== null) {
        titles.push(match[1].trim());
    }

    while ((match = spanRegex.exec(html)) !== null) {
        spans.push(match[1].trim());
    }

    while ((match = bodyRegex.exec(html)) !== null) {
        // Rimuove i caratteri di nuova riga e spazi extra
        const cleanedBody = match[0].replace(/[\r\n]+/g, ' ').trim();
        bodies.push(cleanedBody);
    }

    if (titles.length !== bodies.length || titles.length !== spans.length) {
        logErr('Mismatched number of titles / bodies / spans');
        return false;
    }

    return titles.map((title, index) => ({
        id: index,
        isCollapsed: true,
        isAriaExpanded: false,
        isHidden: true,
        title: title,
        body: bodies[index],
        slug: spans[index]
    }));

};

export default parseTotalServicesHtml;